class EditorialGridToggle extends HTMLElement {
  connectedCallback() {
    this.collection = this.closest('collection-component');
    this.controller?.abort();
    this.controller = new AbortController();

    if (!this.collection) return;

    let density = 'compact';

    try {
      density = localStorage.getItem('editorial-grid-density') || density;
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }

    if (!this.querySelector(`[data-grid-density="${density}"]`)) density = 'compact';
    this.setDensity(density);

    this.querySelectorAll('[data-grid-density]').forEach((button) => {
      button.addEventListener(
        'click',
        () => this.setDensity(button.dataset.gridDensity, true),
        { signal: this.controller.signal }
      );
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  setDensity(density, persist = false) {
    this.collection.dataset.gridDensity = density;

    this.querySelectorAll('[data-grid-density]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.gridDensity === density));
    });

    if (!persist) return;

    try {
      localStorage.setItem('editorial-grid-density', density);
    } catch (_error) {
      // The view still changes for this page when storage is unavailable.
    }
  }
}

if (!customElements.get('editorial-grid-toggle')) {
  customElements.define('editorial-grid-toggle', EditorialGridToggle);
}
